import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private myRoute: Router) {}
  sendToken(token: string) {
    localStorage.setItem("user", token)
  }
  getToken() {
    return localStorage.getItem("user");
  }
  isLoggedIn() {
    let tok = this.getToken();
    return (tok !== "" && tok !== null);
  }
  logout() {
    localStorage.setItem("user", "");
    this.myRoute.navigate(['/login']);
  }
}